module.exports = __webpack_public_path__ + "static/media/logo_ver_fundo_escuro.bf2538ea.png";